import {
    get_cambiGomme,
    create_cambioGomme,
    update_cambioGomme,
    elimina_cambioGomme,
} from "@/api/api.cambiogomme.js";

const cambiGomme = {
    namespaced: true,

    state: {
        lista: [],
    },

    mutations: {
        SET_LISTA: (state, lista) => {
            state.lista = lista;
        },
    },

    actions: {
        carica({ commit }, filtri) {
            return new Promise((resolve, reject) => {
                get_cambiGomme(filtri).then(resp => {
                    commit("SET_LISTA", resp.data);
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        salva({ dispatch }, { id, dati, mezzoId }) {
            const call = id ? update_cambioGomme(id, dati) : create_cambioGomme(dati);
            return new Promise((resolve, reject) => {
                call.then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },

        elimina({ dispatch }, { id, mezzoId }) {
            return new Promise((resolve, reject) => {
                elimina_cambioGomme(id).then(resp => {
                    dispatch("carica", { mezzoId });
                    resolve(resp);
                }).catch(err => reject(err));
            });
        },
    },

    getters: {
        lista: state => state.lista,
    },
};

export default cambiGomme;
